import React from 'react';

export function useScrollToFilterAction() {
    const [scrollToFilter, setScrollToFilterAction] = React.useState<
        string | null
    >(null);

    const getScrollToFilterActionAndReset = React.useCallback(() => {
        setScrollToFilterAction(null);
        return scrollToFilter;
    }, [scrollToFilter]);

    return { setScrollToFilterAction, getScrollToFilterActionAndReset };
}
